module.exports = __webpack_public_path__ + "static/img/activity5.8efb16f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/activity5.jpg
// module id = ogMg
// module chunks = 3